import React, { useState } from "react";
import ReactDOM from "react-dom";

export interface SubmenuItem {
  menuValue: string;
  route?: string;
  children?: SubmenuItem[]; // Suporte a aninhamento
  params?: any; // Parâmetros extras (ex: id_team, id_user)
  isPlaceholder?: boolean; // Novo campo para identificar carregamento
}

interface SubmenuProps {
  items: SubmenuItem[];
  style?: React.CSSProperties;
  className?: string;
  onClose?: () => void;
  onSelect?: (item: SubmenuItem) => void;
  depth?: number; // Para controlar níveis (opcional)
}

const Submenu: React.FC<SubmenuProps> = ({ items, style, className, onClose, onSelect }) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [coords, setCoords] = useState<{ top: number; left: number } | null>(null);

  const handleMouseEnter = (e: React.MouseEvent, index: number) => {
    if (items[index].isPlaceholder) return;
    const rect = e.currentTarget.getBoundingClientRect();
    setCoords({
      top: rect.top,
      left: rect.right, // Posiciona à direita
    });
    setHoveredIndex(index);
  };

  return ReactDOM.createPortal(
    <div
      className={`horizontal-submenu-portal ${className || ""}`}
      style={{
        ...style,
        position: "fixed",
        zIndex: 99999,
        minWidth: "150px",
      }}
      onMouseLeave={() => setHoveredIndex(null)}
    >
      <ul style={{ listStyle: "none", margin: 0, padding: "0.5rem" }}>
        {items.map((item, i) => (
          <li
            key={i}
            onMouseEnter={(e) => handleMouseEnter(e, i)}
            className={`horizontal-submenu-item ${hoveredIndex === i ? "hovered" : ""} ${item.isPlaceholder ? "placeholder" : ""}`}
          >
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (item.isPlaceholder) return;
                if (!item.children || item.children.length === 0) {
                    if (onClose) onClose();
                    if (onSelect) onSelect(item);
                }
              }}
              className="horizontal-submenu-link"
            >
              {item.menuValue}
            </a>
            {item.children && item.children.length > 0 && (
                <span className="horizontal-submenu-arrow">▶</span>
            )}

            {/* Renderiza Submenu Aninhado Recursivamente */}
            {item.children && hoveredIndex === i && coords && (
                <Submenu
                    items={item.children}
                    style={{
                        top: coords.top,
                        left: coords.left,
                    }}
                    onClose={onClose}
                    onSelect={onSelect}
                />
            )}
          </li>
        ))}
      </ul>
    </div>,
    document.body
  );
};

export default Submenu;
